import JSONModel from "sap/ui/model/json/JSONModel";
import Component from "vamos/cockpit/Component";
import FilterOperator from "sap/ui/model/FilterOperator";
import Filter from "sap/ui/model/Filter";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";
import Context from "sap/ui/model/odata/v4/Context";

export default class ClientSettingsService {
  private static instance: ClientSettingsService;

  private appModel: JSONModel;

  private component: Component;

  public static getInstance() {
    if (!this.instance) {
      this.instance = new ClientSettingsService();
    }
    return this.instance;
  }

  public init(component: Component) {
    this.component = component;
    this.appModel = this.component.getModel("app") as JSONModel;
  }

  public async getByParamKey(paramKeys: string | string[]): Promise<string | string[]> {
    paramKeys = Array.isArray(paramKeys) ? paramKeys : [paramKeys];
    const toLoadKeys = paramKeys.filter(key => !this.appModel.getProperty("/ClientSettings/" + key));
    const filters: Filter[] = toLoadKeys.map((key: string) => new Filter("ParamKey", FilterOperator.EQ, key));
    if (filters.length > 0) {
      const listBinding: ODataListBinding = this.component.getModel()
        .bindList("/ClientSettings", undefined, undefined, new Filter(filters)) as ODataListBinding;
      const contexts: Context[] = await listBinding.requestContexts();
      contexts.forEach((context: Context) => {
        this.appModel.setProperty("/ClientSettings/" + context.getProperty("ParamKey"), context.getProperty("ParamValue"));
      });
    }

    const clientSettings: string[] = paramKeys.map(key => this.appModel.getProperty("/ClientSettings/" + key));

    return clientSettings.length === 1 ? clientSettings[0] : clientSettings;
  }


  public setValue(paramKey: string, value: any) {
    this.appModel.setProperty("/ClientSettings/" + paramKey, value);
  }

}


